module.exports = __webpack_public_path__ + "static/media/celebrity.888f6464.png";